/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ actor: NonNullable<unknown>, permission: NonNullable<unknown>, name: NonNullable<unknown> }} Notification_Space_Access_GrantedInputs */



/**
* | output |
* | --- |
* | "{actor} gave you {permission} access to {name}" |
*
* @param {Notification_Space_Access_GrantedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_space_access_granted = /** @type {((inputs: Notification_Space_Access_GrantedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Space_Access_GrantedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.actor} hat Ihnen ${i?.permission}zugriff auf ${i?.name} gegeben`)
	return /** @type {LocalizedString} */ (`${i?.actor} gave you ${i?.permission} access to ${i?.name}`)
});